import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

import DashboardPage from '../dashboard/dashboard-page.component';
import { DASHBOARD_MENU } from '../../../utils/constant.utils';
import { validateAccessModule } from '../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../utils/rbac-constants.utils';
import CreateRequestDisplay from '../../external/request/create-request/create-request-modal-display.component';

class DashboardPageLayout extends Component {

    render() {
        
        let isDashboardReport = window.location.pathname.includes("Dashboard/Report");
        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])
        let accessMyDirectReport = JSON.parse(sessionStorage.getItem('IsCostCodeAuthorizer')) ||
            JSON.parse(sessionStorage.getItem('IsHRLineManager'))
            ? true
            : !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])

        return (
            <div>
                {
                    isDashboardReport && accessMyDirectReport
                        ? (
                            <DashboardPage
                                activeMenu={DASHBOARD_MENU.MyDirectReport}
                                history={this.props.history}>
                                <Route exact path="/external/:dealName/Dashboard/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                                <Route exact path="/external/:dealName/Dashboard/Report/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                            </DashboardPage>
                        )
                        : noAccess
                            ? null
                            : (
                                <DashboardPage
                                    activeMenu={DASHBOARD_MENU.Personal}
                                    history={this.props.history}>
                                    <Route exact path="/external/:dealName/Dashboard/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                                    <Route exact path="/external/:dealName/Dashboard/Report/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                                </DashboardPage>
                            )
                }
            </div>
        )
    }

}

export default DashboardPageLayout;
